import { DefaultBannerWrapperProps, IdMeButtonProps } from "../types";
import { getTextProps } from "./dataProcessing";

export function resolveProcessedTitleSubtitle(
  props: DefaultBannerWrapperProps,
  isSignedIn: boolean | undefined,
  shopperIsInMilitaryGroup: boolean,
  idMeButton: IdMeButtonProps | undefined,
): {
  processedTitle: string;
  processedDescription: string;
} {
  const { textContent } = props;
  const title = textContent?.title ?? "";
  const description = textContent?.description ?? "";
  const isIdMeEnabled = !!idMeButton?.label;

  let processedTitle = "";
  let processedDescription = "";

  if (isIdMeEnabled) {
    const { idMeSignInText, idMeVerificationText, idMePostVerificationText } = idMeButton!;

    if (!isSignedIn && idMeSignInText?.signInTitle) {
      processedTitle = getTextProps(idMeSignInText.signInTitle) ?? "";
    } else if (isSignedIn && !shopperIsInMilitaryGroup && idMeVerificationText?.verificationTitle) {
      processedTitle = getTextProps(idMeVerificationText.verificationTitle) ?? "";
    } else if (
      isSignedIn &&
      shopperIsInMilitaryGroup &&
      idMePostVerificationText?.postVerificationTitle
    ) {
      processedTitle = getTextProps(idMePostVerificationText.postVerificationTitle) ?? "";
    } else {
      processedTitle = getTextProps(title) ?? "";
    }

    if (!isSignedIn && idMeSignInText?.signInSubtitle) {
      processedDescription = getTextProps(idMeSignInText.signInSubtitle) ?? "";
    } else if (
      isSignedIn &&
      !shopperIsInMilitaryGroup &&
      idMeVerificationText?.verificationSubtitle
    ) {
      processedDescription = getTextProps(idMeVerificationText.verificationSubtitle) ?? "";
    } else if (
      isSignedIn &&
      shopperIsInMilitaryGroup &&
      idMePostVerificationText?.postVerificationSubtitle
    ) {
      processedDescription = getTextProps(idMePostVerificationText.postVerificationSubtitle) ?? "";
    } else {
      processedDescription = getTextProps(description) ?? "";
    }
  } else {
    processedTitle = getTextProps(title) ?? "";
    processedDescription = getTextProps(description) ?? "";
  }

  return {
    processedTitle,
    processedDescription,
  };
}
